export const SITE_URL = (process.env.NEXT_PUBLIC_DOMAIN_URL || 'https://hydrashop.vn').replace(/\/$/, '')

export const SCHEMA_IDS = {
  organization: `${SITE_URL}/#organization`,
  localBusiness: `${SITE_URL}/#localbusiness`,
  website: `${SITE_URL}/#website`,
} as const

export const SITE_NAME = 'Hydra Shop'
export const SITE_FULL_NAME = 'Hydra Shop - Thương Hiệu Thời Trang Phong Cách Tối Giản Từ Việt Nam'
export const SITE_DESCRIPTION =
  'Thời trang HYDRA giúp anh em mặc đẹp mỗi ngày không cần lựa chọn. Bền bỉ - mua 1 lần mặc vài năm. Đa dụng - mặc đi đâu cũng được'
export const BRAND_NAME = 'Heil Hydra'
export const URL_GOOGLE_MAP =
  'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3919.26567794549!2d106.65354157548724!3d10.790952289358712!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31752fcbd2274e4d%3A0xe385202cb437a96c!2sC%C3%B4ng%20ty%20TNHH%20HYDRA%20STUDIO!5e0!3m2!1svi!2s!4v1779426212781!5m2!1svi!2s'
